export default __webpack_public_path__ + "static/media/Trumpet.4b5a78f2.png";